<template>
  <div class="lh-homes">
  	<div style="display:none;">
  		<img src="img/b1.png" />
  		<img src="img/figure.png" />
  		<img src="img/b2.png?a=1" />
  		<img src="img/figure2.png" />
  	</div>
    <div class="lh-logo1"><img src="img/logo-a.png" /><span>安全生产：生产前安全准备</span></div>
    <div class="lh-prepare-bg imgs" style="background-image:url(img/b1.png)">
    	<ul class="lh-prepare-item">
			<li v-for="(item,idx) in datas" :class="item.hover" :data-idx="idx" @click="!item.hover?'':setDatas($event)">
				<img :src="item.img">
				<a href="javascript:;" class="click" v-if="item.hover"><img src="img/jt.png"></a>
				<div class="icon">
					<img class="icon1" :src="item.img1" v-if="item.img1" />
					<img class="icon2" :src="item.img2" v-if="item.img2" />
				</div>
			</li>
		</ul>
    </div>
    <div class="lh-prepare-layer">
    	<img :src="datas[datasIdx].layer" />
    	<a href="javascript:;" class="next" @click="next($event)"><img src="img/btn.png"></a>
    </div>
    <div class="lh-prepare-rw">
    	<div class="icon" :style="'background-image:url('+rw+')'"></div>
    </div>
    <Footer :footerData="footerData"></Footer>
  </div>
</template>

<script>
import Footer from '@/components/Footer'
export default{
	data(){
		return {
			footerData:{audioData:{total:'00:00',current:'00:00',percentage:0,icon:'icon-bofang',text:''},page:2,type:'culture'},
			datasIdx:0,
			rw:'img/figure.png',
			datas:[
				{img:'img/b2.png?a=1',layer:'img/b9.png?a=1',hover:'on',end:'',x:'44vw',web:'65vw',duration:'1.5'},
				{img:'img/b3.png',layer:'img/b10.png?a=1',hover:'',end:'',x:'-42vw',web:'-72vw',duration:'1.5'},
				{img:'img/b4.png',layer:'img/b11.png?a=1',hover:'',end:'',x:'-105vw',web:'-140vw',duration:'2'},
				{img:'img/b5.png',layer:'img/b12.png?a=1',hover:'',end:'',x:'-155vw',web:'-203vw',duration:'2'},
				{img:'img/b8.png',img1:'img/b7.png',img2:'img/b6.png?a=1',layer:'img/b12.png',hover:'',end:'',x:'-200vw',web:'-270vw',duration:'2'}
			]
		}
	},
	created(e){
		var that=this;
	},
	mounted(e){
      var that=this;
      if(width<=980){
          that.web=true;
      }
    },
	components:{
		Footer
	},
	methods:{
		setDatas(e){
			var that=this,tag = $(e.currentTarget),idx=$(e.currentTarget).data('idx');
			that.datas[idx].hover="";
			if(idx===0){
				$('.lh-prepare-rw .icon').css({'animation-play-state':'running'});
				$('.lh-prepare-rw').css({left:that.web?that.datas[idx].web:that.datas[idx].x,transition:'linear '+that.datas[idx].duration+'s'});
				setTimeout(function(){
					$('.lh-prepare-rw .icon').css({'animation-play-state':'paused'});
					$('.lh-homes').addClass('Layers');	
				},that.datas[idx].duration*1000);
			}else if(idx===4){
				$('.lh-prepare-item li:nth-child(5) .icon1').css({transform:'translateY(-100%)'});
				setTimeout(function(){
					that.$router.replace({ path: 'prepare2'});
				},1000);
			}else{
				$('.lh-homes').addClass('Layers');
				$('.lh-prepare-bg').css({'transform':'translateX('+(that.web?that.datas[idx].web:that.datas[idx].x)+')',transition:'linear '+that.datas[idx].duration+'s'});
			}
			if(idx===2){
				setTimeout(function(){
					that.rw='img/figure2.png';
				},450);
			}
		},
		next(e){
			var that=this,tag = $(e.currentTarget);
			that.datasIdx+=1;
			$('.lh-homes').removeClass('Layers');
			$('.lh-prepare-rw .icon').css({'animation-play-state':'running'});
			//$('.lh-prepare-rw').css({left:'5vw',transition:'linear '+that.datas[that.datasIdx].duration+'s'});
		    $('.lh-prepare-bg').css({'transform':'translateX('+(that.web?that.datas[that.datasIdx].web:that.datas[that.datasIdx].x)+')',transition:'linear '+that.datas[that.datasIdx].duration+'s'});
		    setTimeout(function(){
				$('.lh-prepare-rw .icon').css({'animation-play-state':'paused'});
				that.datas[that.datasIdx].hover="on";
				if(that.datasIdx===4){
					that.rw='img/b13.png';
					$('.lh-prepare-rw').addClass('end');
				}
		    },that.datas[that.datasIdx].duration*1000);
		},
		gotoNext(e){
			var that=this,tag = $(e.currentTarget),path=$(e.currentTarget).data('path');
			that.$router.replace({ path: path});
		}
	}
}
</script>
